import { ToastService } from 'src/app/services/toast.service';
import { inject } from '@angular/core';
import { Component, EventEmitter, OnInit, OnDestroy, Output, HostListener , ChangeDetectorRef } from '@angular/core';
import { WizardStateService } from '../../../../services/wizard-state.service';
import { CurrentUserService } from '../../../../../../services/current-user.service';
import { AiPortraitTokenService } from '../../../../../../pages/player/modals/ai-generation/service/ai-portrait-token.service';
import { SubscriptionService } from '../../../../../../pages/subscription/services/subscription.service';
import { AiGenerationMode } from '../../../../constants/ai-modes.constants';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-ai-mode-confirm-step',
    templateUrl: './ai-mode-confirm-step.component.html',
    styleUrls: ['./ai-mode-confirm-step.component.scss'],
    standalone: false
})
export class AiModeConfirmStepComponent implements OnInit, OnDestroy {
  private readonly toasts = inject(ToastService);
  @Output() next = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  mapName = 'your world';
  selectedMode: AiGenerationMode | null = null;
  creditsBalance = 0;
  creditsRequired = 1;

  purchasePack: any = null;
  isLoading = false;

  private userId: any = null;
  private userSub: Subscription | null = null;

  AiGenerationMode = AiGenerationMode;

  constructor(private stateService: WizardStateService,
    private currentUserService: CurrentUserService,
    private tokenService: AiPortraitTokenService,
    private subscriptionService: SubscriptionService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    const state = this.stateService.currentState;
    this.mapName = state.mapName || 'your world';
    this.selectedMode = state.aiMode;

    this.userSub = this.currentUserService.currentUser.subscribe(user => {
      if (user) {
        this.userId = user.id || user.user_id;
        this.fetchCreditBalance();
        this.fetchTokenPacks();
      }
    
          this.cdr.detectChanges();});
  }

  ngOnDestroy(): void {
    if (this.userSub) {
      this.userSub.unsubscribe();
    }
  }

  fetchCreditBalance(): void {
    if (!this.userId) return;
    this.tokenService.getTokenBalance(this.userId).subscribe({
      next: (res: any) => {
        if (res && res.breakdown) {
          this.creditsBalance = res.breakdown.world_credits || 0;
        }
      
          this.cdr.detectChanges();},
      error: (err) => {
        console.error('Error fetching credit balance:', err);
      
          this.cdr.detectChanges();}
    });
  }

  fetchTokenPacks(): void {
    this.isLoading = true;
    this.subscriptionService.getStripeProducts().subscribe({
      next: (res: any) => {
        if (res && res.token_packs) {
          const wcreditPacks = res.token_packs.filter((product: any) => product.pack_type === 'wcredit');
          if (wcreditPacks.length > 0) {
            // Sort ascending by price and pick the first one
            this.purchasePack = wcreditPacks.sort((a: any, b: any) => Number(a.price) - Number(b.price))[0];
          }
        }
        this.isLoading = false;
      
          this.cdr.detectChanges();},
      error: (err) => {
        console.error('Error fetching token packs:', err);
        this.isLoading = false;
      
          this.cdr.detectChanges();}
    });
  }

  buyProduct(): void {
    if (!this.userId || !this.purchasePack) {
      this.toasts.showNote("Purchase options aren't ready yet. Please try again in a moment.", 'warning');
      return;
    }
    this.subscriptionService.createTokenPackCheckoutSession(this.userId, this.purchasePack.id).subscribe({
      next: (res: any) => {
        if (res && res.checkout_url) {
          // Open Stripe in a new tab rather than navigating away — this tab (and the
          // wizard's in-memory state) stays alive, so the user resumes exactly where
          // they left off once they return here after paying.
          window.open(res.checkout_url, '_blank');
        } else {
          this.toasts.showNote("We couldn't start checkout. Please try again.", 'danger');
        }
      
          this.cdr.detectChanges();},
      error: (err) => {
        console.error('Error starting checkout:', err);
        this.toasts.showNote("We couldn't reach the payment service. Check your connection and try again.", 'danger');
      
          this.cdr.detectChanges();}
    });
  }

  /** Refresh the credit balance the moment the user comes back to this tab after checkout. */
  @HostListener('window:focus')
  onWindowFocus(): void {
    this.fetchCreditBalance();
  }

  onProceed(): void {

    this.next.emit();
  }

  onBack(): void {
    this.back.emit();
  }
}
